import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Modal from 'react-responsive-modal';
import "../articles/articles.css";
import "./homePage.css";
class HistoryItem extends Component {
  

    constructor(props){
      super(props);
    }
    render() {
    	return (
	      <div className="HistoryItem">


            <img className="HistoryItemImage" src={this.props.history.image} alt=""/>

            <div className="HistoryItemDate">{this.props.history.date}</div>
            <div className="HistoryItemDesc">{this.props.history.desc}</div>

	      </div>
	    );
    }
}

export default HistoryItem;
